export const query_rischi_byPrestazione = `
query getRischiByPrestazione($prestazioneId: Int!) {
  rischio(where: {PrestazioneId: {_eq: $prestazioneId}}, order_by: {Date: desc}) {
    Id
    PrestazioneId
    Date
    SpA1Livello
    SpA1_1
    SpA1_2
    SpA1_3
    SpA1_4
    SpA1_5
    SpA1_6
    SpA1_7
    SpA1Altro
    SpA1AltroNote
    SpA2Livello
    SpA2_1
    SpA2_2
    SpA2_3
    SpA2Altro
    SpA2AltroNote
    SpA3Livello
    SpA3_1
    SpA3_2
    SpA3_3
    SpA3_4
    SpA3Altro
    SpA3AltroNote
    SpA4Livello
    SpA4_1
    SpA4_2
    SpA4_3
    SpA4_4
    SpA4Altro
    SpA4AltroNote
    SpASubTotale
    SpB1Livello
    SpB1_1
    SpB1_2
    SpB1_3
    SpB1_4
    SpB1Altro
    SpB1AltroNote
    SpB2Livello
    SpB2_1
    SpB2_2
    SpB2_3
    SpB2_4
    SpB2Altro
    SpB2AltroNote
    SpB3Livello
    SpB3_1
    SpB3_2
    SpB3_3
    SpB3Altro
    SpB3AltroNote
    SpB4Livello
    SpB4_1
    SpB4_2
    SpB4_3
    SpB4Altro
    SpB4AltroNote
    SpB5Livello
    SpB5_1
    SpB5_2
    SpB5_3
    SpB5Altro
    SpB5AltroNote
    SpB6Livello
    SpB6_1
    SpB6_2
    SpB6_3
    SpB6_4
    SpB6Altro
    SpB6AltroNote
    SpB7Livello
    SpBSubTotale
    SpC1_1_Livello
    SpC1_2_Livello
    SpC1_3_Livello
    SpCSubTotale
    EfRiTotale
    EfSpTotale
    EfTotale
    EfAdeguataLivello
    ProvidedBy
    CreatedOn
    ModifiedOn
    HasTabellaB
    DataControlloCostante
    CreatedBy
    ModifiedBy
    HasTitEffPep
  }
}`;
export const query_rischi_byPrestazione_count = `
query countRischiByPrestazione($tenantId: String!, $aziendaId: Int!, $prestazioneId: Int!) {
  rischio_aggregate(where: {
    prestazione: {fascicolo: {TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId}}, Id : {_eq: $prestazioneId}}
  }, distinct_on: PrestazioneId) {
    aggregate {
      count(columns: Id)
    }
  }
}`;
export const query_rischi_byTenant = `
query getRischiByTenant($tenantId: String!, $aziendaId: Int!, $userId: String!) {
  rischio(where: {
    prestazione: {
      fascicolo: {
        TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
        _or: [
          {_or: [{IsPrivate: {_eq: false}}]},
          {_or: [
            {prestaziones: {prestazione_users: {UserId: {_eq: $userId}}}}
          ]}
        ]
      }
    }
  }, order_by: {Date: desc}) {
    Id
    PrestazioneId
    Date
    SpA1Livello
    SpA1_1
    SpA1_2
    SpA1_3
    SpA1_4
    SpA1_5
    SpA1_6
    SpA1_7
    SpA1Altro
    SpA1AltroNote
    SpA2Livello
    SpA2_1
    SpA2_2
    SpA2_3
    SpA2Altro
    SpA2AltroNote
    SpA3Livello
    SpA3_1
    SpA3_2
    SpA3_3
    SpA3_4
    SpA3Altro
    SpA3AltroNote
    SpA4Livello
    SpA4_1
    SpA4_2
    SpA4_3
    SpA4_4
    SpA4Altro
    SpA4AltroNote
    SpASubTotale
    SpB1Livello
    SpB1_1
    SpB1_2
    SpB1_3
    SpB1_4
    SpB1Altro
    SpB1AltroNote
    SpB2Livello
    SpB2_1
    SpB2_2
    SpB2_3
    SpB2_4
    SpB2Altro
    SpB2AltroNote
    SpB3Livello
    SpB3_1
    SpB3_2
    SpB3_3
    SpB3Altro
    SpB3AltroNote
    SpB4Livello
    SpB4_1
    SpB4_2
    SpB4_3
    SpB4Altro
    SpB4AltroNote
    SpB5Livello
    SpB5_1
    SpB5_2
    SpB5_3
    SpB5Altro
    SpB5AltroNote
    SpB6Livello
    SpB6_1
    SpB6_2
    SpB6_3
    SpB6_4
    SpB6Altro
    SpB6AltroNote
    SpB7Livello
    SpBSubTotale
    SpC1_1_Livello
    SpC1_2_Livello
    SpC1_3_Livello
    SpCSubTotale
    EfRiTotale
    EfSpTotale
    EfTotale
    EfAdeguataLivello
    ProvidedBy
    CreatedOn
    ModifiedOn
    HasTabellaB
    DataControlloCostante
    CreatedBy
    ModifiedBy
    prestazione {
      StartDate
      EndDate
      fascicolo {
        Id
        Name
      }
      base_tipo_prestazione {
        BaseTenantTipoId
        Nome
        Rischio
      }
      base_scopo_prestazione {
        Value
      }
      base_natura_prestazione {
        Value
      }
    }
  }
}`;
export const query_rischio_byId = `
query getRischiByTenant($tenantId: String!, $aziendaId: Int!, $userId: String!, $id: Int!) {
  rischio(where: {
    Id: {_eq: $id },
    prestazione: {
      fascicolo: {
        TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
        _or: [
          {_or: [{IsPrivate: {_eq: false}}]},
          {_or: [
            {anagrafica_fascicolos: {anagrafica: {anagrafica_identificaziones: {IdentifiedByUser: {_eq: $userId}}}}},
            {prestaziones: {prestazione_user: {UserId: {_eq: $userId}}}}
          ]}
        ]
      }
    }
  }, order_by: {Date: desc}) {
    Id
    PrestazioneId
    Date
    SpA1Livello
    SpA1_1
    SpA1_2
    SpA1_3
    SpA1_4
    SpA1_5
    SpA1Altro
    SpA1AltroNote
    SpA2Livello
    SpA2_1
    SpA2_2
    SpA2_3
    SpA2Altro
    SpA2AltroNote
    SpA3Livello
    SpA3_1
    SpA3_2
    SpA3_3
    SpA3_4
    SpA3Altro
    SpA3AltroNote
    SpA4Livello
    SpA4_1
    SpA4_2
    SpA4Altro
    SpA4AltroNote
    SpASubTotale
    SpB1Livello
    SpB1_1
    SpB1_2
    SpB1_3
    SpB1_4
    SpB1Altro
    SpB1AltroNote
    SpB2Livello
    SpB2_1
    SpB2_2
    SpB2_3
    SpB2_4
    SpB2Altro
    SpB2AltroNote
    SpB3Livello
    SpB3_1
    SpB3_2
    SpB3Altro
    SpB3AltroNote
    SpB4Livello
    SpB4_1
    SpB4_2
    SpB4Altro
    SpB4AltroNote
    SpB5Livello
    SpB5_1
    SpB5_2
    SpB5_3
    SpB5Altro
    SpB5AltroNote
    SpB6Livello
    SpB6_1
    SpB6_2
    SpB6_3
    SpB6Altro
    SpB6AltroNote
    SpB7Livello
    SpBSubTotale
    SpC1_1_Livello
    SpC1_2_Livello
    SpC1_3_Livello
    SpCSubTotale
    EfRiTotale
    EfSpTotale
    EfTotale
    EfAdeguataLivello
    ProvidedBy
    CreatedOn
    ModifiedOn
    HasTabellaB
    DataControlloCostante
    CreatedBy
    ModifiedBy
    prestazione {
      fascicolo {
        Id
        Name
      }
      base_tipo_prestazione {
        Nome
        Rischio
      }
      base_scopo_prestazione {
        Value
      }
      base_natura_prestazione {
        Value
      }
    }
  }
}`;
export const query_rischi_byDataControlloCostante = `
query getRischiByTenant($tenantId: String!, $aziendaId: Int!, $tenantTipoId: Int!, $dtFrom: timestamp!, $dtTo: timestamp!) {
  rischio(where: {
    prestazione: {
      base_tipo_prestazione: {BaseTenantTipoId: {_eq: $tenantTipoId}},
      fascicolo: {
        TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
        _or: [
          {IsPrivate: {_eq: false}}
        ]
      },
      _not: {
        rischios: {
          DataControlloCostante: {_gt: $dtTo}
        }
      }
    },
    _and:[
      {DataControlloCostante: {_gte: $dtFrom}},
      {DataControlloCostante: {_lte: $dtTo}}
    ]
  }, 
  distinct_on: PrestazioneId,
  order_by: [
    {PrestazioneId: asc},
    {DataControlloCostante: desc}
  ]) {
    Id
    PrestazioneId
    DataControlloCostante
    prestazione {
      fascicolo {
        Id
        Name
      }
    }
  }
}`;